import Vue from 'vue';
import dotProp from 'dot-prop';
import { offsetTop } from '@/helpers/utils';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export const Configurator = {
    state: {},
    mutations: {},
    getters: {
        getActiveConfiguratorView(state, getters, rootState) {
            if (rootState.route.query.configurator_view) {
                return rootState.route.query.configurator_view;
            }
            return null;
        },
        getActiveConfiguratorGroup(state, getters, rootState) {
            if (rootState.route.query.configurator_group) {
                return rootState.route.query.configurator_group;
            }
            return null;
        },
        isShadowed(state, getters) {
            return (source, preset) => {
                if (!preset || source.indexOf('data.') === -1) {
                    return false;
                }
                let presets = getters.getProp(preset),
                    preset_id = getters.getProp(
                        source.substring(0, source.lastIndexOf('.data')) + '.preset_id'
                    );
                if (preset_id === undefined) {
                    return false;
                }
                let preset_object = Object.values(presets).find(
                    (presets__value) => presets__value.id === preset_id
                ).data;
                if (typeof preset_object === 'function') {
                    preset_object = preset_object({ getters: getters });
                }
                return (
                    dotProp.get(
                        preset_object,
                        source.substring(source.lastIndexOf('data.') + 'data.'.length)
                    ) !== undefined
                );
            };
        },
        isConfiguratorActive(state, getters, rootState) {
            if (rootState.route.query.configurator) {
                // also check if item really exists
                if (
                    rootState.route.query.module_id &&
                    getters.moduleExists(rootState.route.query.module_id)
                ) {
                    return true;
                }
                if (
                    rootState.route.query.menu_id &&
                    getters.menuExists(rootState.route.query.menu_id)
                ) {
                    return true;
                }
                return false;
            }
            return false;
        }
    },
    actions: {
        scrollVerticalCenterModule(context, { id, delay = 100, speed = 'auto' }) {
            Vue.nextTick().then(() => {
                setTimeout(() => {
                    let moduleDom = document.querySelector('.module[data-id="' + id + '"]'),
                        moduleOffset = offsetTop(moduleDom),
                        moduleHeight = moduleDom.offsetHeight,
                        pageDom = document.querySelector('.page-wrap'),
                        pageHeight = pageDom.offsetHeight,
                        top = moduleOffset;
                    if (pageHeight > moduleHeight) {
                        top -= (pageHeight - moduleHeight) / 2;
                    }
                    if (speed === 'auto') {
                        pageDom.scroll({ top: top, left: 0, behavior: 'smooth' });
                    } else {
                        pageDom.scrollTop = top;
                    }
                }, delay);
            });
        }
    }
};
